// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e36c5f17","977":"1a291bb1"}[chunkId] + ".chunk.js";
};